module.exports = __webpack_public_path__ + "static/media/me-eyes-forward.98ec424a.svg";